import { Input, Component, OnInit, SimpleChanges, OnChanges } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { IBannerDetails, IBanner, MAX_BANNERS } from 'rev-portal/scheduledEvents/common/BannerTypes';

import { DialogService } from 'rev-shared/ui/dialog/Dialog.Service';
import { noop } from 'rev-shared/util';

import { BannerService } from './Banner.Service';

@Component({
	selector: 'vb-webcast-banner-sidebar',
	templateUrl: './VbWebcastBannerSidebar.Component.html',
	standalone: false
})
export class VbWebcastBannerSidebarComponent implements OnInit, OnChanges {
	@Input() public bannerDetails!: IBannerDetails;
	@Input() public webcastId!: string;

	public readonly MAX_BANNERS = MAX_BANNERS;
	public readonly isDuplicateName = linkName => this.banners.filter(c => c.name === linkName).length > 1;
	public readonly isDuplicateNameForForm = linkName => this.banners.some((c, index) => c.name === linkName && index !== this.editingBannerIndex);

	public banners: IBanner[] = [];
	public newBanner: IBanner | null = null;
	public isAddingNewBanner = false;
	public editingBannerIndex: number | null = null;

	constructor(
		private readonly BannerService: BannerService,
		private readonly Translate: TranslateService,
		private readonly Dialog: DialogService
	) { }

	public ngOnInit(): void {
		this.banners = this.bannerDetails.banners.map(link => ({ ...link }));

	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes.bannerDetails) {
			this.banners = this.bannerDetails.banners.map(link => ({ ...link }));
		}
	}

	public onAddNewClick(): void {
		this.newBanner = {
			name: '',
			message: '',
			link: '',
			pushMethod: 'Manual'
		};
		this.editingBannerIndex = null;
		this.isAddingNewBanner = true;
	}

	public onEditEntry(index: number): void {
		this.newBanner = { ...this.banners[index] };
		this.editingBannerIndex = index;
		this.isAddingNewBanner = true;
	}

	public onSaveEntry(banner: IBanner): void {
		if (this.editingBannerIndex !== null) {
			this.banners[this.editingBannerIndex] = {
				...this.banners[this.editingBannerIndex],
				...banner
			};
			this.BannerService.updateBanner(this.webcastId, this.banners[this.editingBannerIndex]);
		} else {
			const bannerToAdd = { ...banner };

			this.banners.push(bannerToAdd);
			this.BannerService.addBanner(this.webcastId, bannerToAdd);
		}

		this.newBanner = null;
		this.editingBannerIndex = null;
		this.isAddingNewBanner = false;
	}

	public onCancelAddEntry(): void {
		this.newBanner = null;
		this.editingBannerIndex = null;
		this.isAddingNewBanner = false;
	}

	public onUpdateEntry(index: number): void {
		this.BannerService.updateBanner(this.webcastId, this.banners[index]);
	}

	public onDeleteEntry(index: number): void {
		const banner = this.banners[index];

		if (banner?.id) {
			const bannerId = banner.id;
			this.Dialog.openConfirmationDialog(
				{
					title: this.Translate.instant('Event_Banner_Delete'),
					message: this.Translate.instant('Event_Banner_Delete_Msg'),
					actionText: this.Translate.instant('Ok'),
					cancelText: this.Translate.instant('Cancel'),
					themed: true
				}
			).result
				.then(() => {
					this.BannerService.deleteBanner(this.webcastId, bannerId);
				})
				.catch(noop);
		} else {
			this.banners = this.banners.filter(c => c.id);
		}
	}

	public isAddNewDisabled(): boolean {
		return this.isAddingNewBanner || this.banners?.length >= this.MAX_BANNERS;
	}

}
